export default __webpack_public_path__ + "static/media/clock-solid.b596a403.svg";